// Based on: https://github.com/zetsnotdead/ng-programmatic-animation-construction
import { Directive, Input, ElementRef } from '@angular/core';
import { AnimationPlayer, AnimationBuilder, AnimationMetadata, style, animate, keyframes } from '@angular/animations';

@Directive({
    selector: '[finderTransitionIn]'
})
export class FinderTransitionInDirective {
    /**
     * @description Translation value to begin y-axis transition from (default: `100px`)
     */
    @Input() transitionYStart = '100px';

    /**
     * @description Length of translation animation in milliseconds (default: `800`)
     */
    @Input() transitionDuration = 800;

    player: AnimationPlayer;

    @Input()
    set finderTransitionIn(transitionIn: boolean) {
        if (this.player) {
            this.player.destroy();
        }

        const metadata = transitionIn ? this.show() : this.hide();
        const factory = this.builder.build(metadata);
        const player = factory.create(this.elementRef.nativeElement);

        player.play();
    }

    constructor(
        private builder: AnimationBuilder,
        private elementRef: ElementRef
    ) { }

    private show(): AnimationMetadata[] {
        return [
            style({transform: `translateY(${this.transitionYStart})`, opacity: 0}),
            animate(this.transitionDuration, style({transform: 'translateY(0)', opacity: 1}))
        ];
    }

    private hide(): AnimationMetadata[] {
        return [
            style({ opacity: 0 })
        ];
    }
}
